import { Col, Row, Card } from 'react-bootstrap';

const especialidadesLaborales = [
  { title: 'Despidos', desc: 'Sea cual sea la causa o el tipo de despido, asesorate. Tenés derechos que pueden incrementar significativamente la indemnización que te corresponde.' },
  { title: 'Indemnización', desc: 'Reclamá la máxima indemnización. No te conformes con menos. En many casos, te corresponde una suma mayor y quizás no lo sepas.' },
  { title: 'Trabajo en negro', desc: 'Si no estás registrado o lo estás de manera incorrecta, asesorate, porque tenés derechos importantes que te corresponden.' },
  { title: 'Accidentes de trabajo', desc: 'Reclamá la indemnización que realmente te corresponde. No aceptes menos. Asesorate con nuestros abogados antes de firmar, para conocer todos los detalles de tu caso.' },
  { title: 'Enfermedad Laboral', desc: 'Si tu salud empeoró debido a tu trabajo, es posible que estés padeciendo una enfermedad profesional. Asesorate, porque te corresponde una indemnización.' },
  { title: 'Horas extras', desc: 'Un abuso frecuente de algunos empleadores es no pagar las horas extras y nocturnas como corresponde. Asesorate, porque podés reclamar hasta 2 años de deuda.' },
  { title: 'Diferencia salarial', desc: 'Si tu sueldo es inferior al del Convenio Colectivo de Trabajo, no te pagan los adicionales, aumentos o conceptos no remunerativos, o cobrás menos que tus compañeros o por debajo del valor real, asesorate.' },
  { title: 'Renuncia', desc: 'Si renunciaste porque te obligaron o como condición, o si hubo irregularidades en tu relación laboral, asesorate. Es posible que te corresponda una indemnización.' }
];

const FeaturesLaboral = () => {
  return (
    <section className="bg-body pt-10 pb-10" id="derecholaboral">
      <div className="container-small px-lg-7 px-xxl-3">
        <div className="text-center mb-8">
          <h2 className="fs-3 fs-lg-2">Derecho <span className="text-primary">Laboral</span></h2>
          <p className="text-muted">Nos especializamos en:</p>
        </div>
        
        <Row className="g-4">
          {especialidadesLaborales.map((item, idx) => (
            <Col key={idx} xs={12} md={6} lg={3}>
              <Card className="h-100 border border-translucent card-hover shadow-sm">
                <Card.Body className="p-4">
                  <h4 className="fw-bolder text-body-emphasis mb-3">{item.title}</h4>
                  <p className="text-body-tertiary fs-9 mb-0">{item.desc}</p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        <div className="text-center mt-6">
          <a 
            href="https://api.whatsapp.com/send/?phone=5491153069479&text&type=phone_number&app_absent=0" 
            target="_blank" 
            rel="noopener noreferrer"
            className="btn btn-primary rounded-pill px-4 py-2 fw-bold"
          >
            Consultar ahora
          </a>
        </div>
      </div>
    </section>
  );
};

export default FeaturesLaboral;